"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createType = exports.registry = exports.types = exports.content = exports.proposals = exports.workingGroup = exports.forum = exports.council = exports.members = exports.common = void 0;
const common_1 = __importDefault(require("./common"));
exports.common = common_1.default;
const members_1 = __importDefault(require("./members"));
exports.members = members_1.default;
const council_1 = __importDefault(require("./council"));
exports.council = council_1.default;
const forum_1 = __importDefault(require("./forum"));
exports.forum = forum_1.default;
const working_group_1 = __importDefault(require("./working-group"));
exports.workingGroup = working_group_1.default;
const storage_1 = __importDefault(require("./storage"));
const blog_1 = __importDefault(require("./blog"));
const proposals_1 = __importDefault(require("./proposals"));
exports.proposals = proposals_1.default;
const referendum_1 = __importDefault(require("./referendum"));
const constitution_1 = __importDefault(require("./constitution"));
const bounty_1 = __importDefault(require("./bounty"));
const content_1 = __importDefault(require("./content"));
exports.content = content_1.default;
const types_1 = require("@polkadot/types");
exports.types = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, common_1.default), members_1.default), council_1.default), forum_1.default), working_group_1.default), storage_1.default), blog_1.default), proposals_1.default), referendum_1.default), constitution_1.default), bounty_1.default), content_1.default), { 
    // https://github.com/polkadot-js/api/blob/master/CHANGELOG.md#351-jan-18-2020
    AccountInfo: 'AccountInfoWithRefCount' });
// Allows creating types without api instance (it's not a recommended way though, so should be used just for mocks)
exports.registry = new types_1.TypeRegistry();
exports.registry.register(exports.types);
function createType(typeName, value) {
    return exports.registry.createType(typeName, value);
}
exports.createType = createType;
